import { observer } from 'mobx-react-lite';
import { ReactElement, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { ImageSegmentationsContextProvider } from '../../annotation/submodules/segmentations/segmentationContextMenu/imageSegmentations.context';
import { DatasetDetails } from '../DatasetDetails.context';
import { DatasetDetailsImagePreviewContainer } from './DatasetDetailsImagePreview.container';

export const DatasetDetailsPreviewContainer = observer((): ReactElement => {
  const { store } = useContext(DatasetDetails);
  const { imageId } = useParams<{ imageId: string }>();

  return (
    <ImageSegmentationsContextProvider imageId={imageId}>
      <DatasetDetailsImagePreviewContainer
        height={(store.imagePreviewInfo && store.imagePreviewInfo.height) || 0}
        width={(store.imagePreviewInfo && store.imagePreviewInfo.width) || 0}
        url={(store && store.imagePreviewUrl) || ''}
        lowQualityUrl={(store && store.lowQualityImagePreviewUrl) || ''}
        isLoading={store.isPreviewImageLoading}
      />
    </ImageSegmentationsContextProvider>
  );
});
